// extracted by mini-css-extract-plugin
module.exports = {"link-back":"styles_link-back__3dinx"};